import { Injectable, effect, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DemoModeService {
  private readonly STORAGE_KEY = 'levea-demo-mode';

  readonly isDemo = signal<boolean>(this.getStoredDemoMode());

  constructor() {
    effect(() => {
      const enabled = this.isDemo();
      this.applyBodyClass(enabled);
      this.saveDemoMode(enabled);
    });
  }

  toggle(): void {
    this.isDemo.set(!this.isDemo());
  }

  enable(): void {
    this.isDemo.set(true);
  }

  disable(): void {
    this.isDemo.set(false);
  }

  private getStoredDemoMode(): boolean {
    if (typeof localStorage === 'undefined') return false;
    return localStorage.getItem(this.STORAGE_KEY) === 'true';
  }

  private saveDemoMode(enabled: boolean): void {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(this.STORAGE_KEY, String(enabled));
  }

  private applyBodyClass(enabled: boolean): void {
    if (typeof document === 'undefined') return;
    document.body.classList.toggle('demo-mode', enabled);
  }
}
